import styled, { css } from 'styled-components';
import { p, pl, mt } from 'styled-components-spacing';
import breakpoint from 'styled-components-breakpoint';
import theme from '@theme';

const { borderRadius, colors } = theme;

export const inputStyles = css`
  ${borderRadius.small}
  ${p(2.5)}
  ${pl(3.5)}
  ${mt(2)}
  /* background-color: ${colors.lightGray}; */
  box-sizing: border-box;
  font-size: 1rem;
  display: block;
  width: 100%;
  background-color: ${({ greyBlue }) => (greyBlue ? colors.lightGray : colors.white)};
  border : ${({ noborder }) => (noborder ? 'none' : `1px solid ${colors.translucentDarkBlue}`)};
  ${breakpoint('mobile', 'desktop')`
    ${({ roundedMobile }) => roundedMobile && 'border-radius: 10px'};
  `}

  ${breakpoint('desktop')`
    ${pl(2.5)}
  `}
  ${breakpoint('mobile', 'tablet')`
    ${({ campaign }) => campaign
      && `
        font-size: 12px;
        padding: 0.5rem;
    `};
  `}

`;

export const StyledInput = styled.input`
  ${inputStyles}
  width: ${props => (props.width ? '50%' : '100%')};
  &[type='date'] {
    appearance: textfield;
  }
`;
